import BookForYou from "../components/screens/libro/bookForYou/BookForYou"
/*import BookHero from "../components/screens/libro/bookHero/BookHero"*/
import BookOverview from "../components/screens/libro/bookOverview/BookOverview"
import BookStructure from "../components/screens/libro/bookStructure/BookStructure"
import CollectiveWork from "../components/screens/libro/collectiveWork/CollectiveWork"
import Contributors from "../components/screens/libro/contributors/Contributors"
import FreeDownload from "../components/screens/libro/freeDownload/FreeDownload"
import KeyThinkers from "../components/screens/libro/keyThinkers/KeyThinkers"
import MenstrualEducation from "../components/screens/libro/menstrualEducation/MenstrualEducation"
import MenstrualEducationWhy from "../components/screens/libro/menstrualEducationWhy/MenstrualEducationWhy"
import PhotoArchive from "../components/screens/libro/photoArchive/PhotoArchive"
import NewsletterCTA from "../components/NewsletterCTA"

const Libro = () => {
  return (
    <>
      <MenstrualEducation />
      <BookOverview /> 
      <MenstrualEducationWhy />
      <BookForYou />
      <CollectiveWork />
      <BookStructure />  
      <Contributors />
      <KeyThinkers />
      <FreeDownload />
      <PhotoArchive /> 
      <NewsletterCTA />
    </>
  )
}

export default Libro